// CustomerSelect.js - Search and select customer for invoice/quote
import React, { useEffect, useState } from 'react';
import { AutoComplete, Input, Spin } from 'antd';
import { useAuth } from '../../AuthProvider';
import { baseUrl_SPB } from '../../BaseUrl';

const CustomerSelect = ({ value, onChange }) => {
  const authContext = useAuth();
  const [options, setOptions] = useState([]);
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(false);
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    if (value && typeof value === 'object') setSelected(value);
  }, [value]);

  // Helper to get display name
  const getDisplayName = (option) => {
    if (!option) return '';
    if (option.businessName) return option.businessName;
    return `${option.firstName || ''} ${option.lastName || ''}`.trim();
  };

  const fetchCustomers = async (query) => {
    setLoading(true);
    try {
      const response = await fetch(`${baseUrl_SPB}/api/v1/businesscustomers/getcustomers`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + authContext.token,
        },
      });
      if (!response.ok) throw new Error('Failed to fetch customers');
      let data = await response.json();
      data = data.map(item => {
        const name = `${item.firstName || ''} ${item.lastName || ''}`.trim();
        let label = name;
        if (item.email) {
          label = `${name} (${item.email})`;
        }
        return {
          value: item.id,
          label,
          ...item
        };
      });
      if (query) {
        const lower = query.toLowerCase();
        data = data.filter(item =>
          (item.firstName && item.firstName.toLowerCase().includes(lower)) ||
          (item.lastName && item.lastName.toLowerCase().includes(lower)) ||
          (item.email && item.email.toLowerCase().includes(lower)) ||
          (item.phoneNumber && item.phoneNumber.toLowerCase().includes(lower)) ||
          (item.businessName && item.businessName.toLowerCase().includes(lower)) ||
          (item.abn && item.abn.toLowerCase().includes(lower))
        );
      }
      setOptions(data);
    } catch (err) {
      setOptions([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCustomers(search);
    // eslint-disable-next-line
  }, [search]);

  return (
    <AutoComplete
      style={{ width: '100%' }}
      options={options}
      value={selected ? selected.label : search}
      onSearch={setSearch}
      onSelect={(_, option) => {
        setSelected(option);
        onChange && onChange(option);
      }}
      notFoundContent={loading ? <Spin size="small" /> : null}
      placeholder="Search customer by name, email, phone, business, ABN..."
      filterOption={false}
    >
      <Input />
    </AutoComplete>
  );
};

export default CustomerSelect;
